var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Layout',[_c('ProjectOverview',{staticClass:"spacing"})],1),_c('UploadButton',{staticClass:"upload-button"}),_c('ClaimButton',{staticClass:"claim-button"}),_c('DeleteButton',{staticClass:"delete-button"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }